/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Pos_LeftInputs */

const vi_shop_home_pos_left = /** @type {(inputs: Shop_Home_Pos_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trái`)
};

/**

* @param {Shop_Home_Pos_LeftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_pos_left = /** @type {((inputs?: Shop_Home_Pos_LeftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Pos_LeftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_pos_left(inputs)
});